import { epoch, utc } from '../../util/datetime';
import { YesNoOption } from '../global/YesNoOption.enum';
import type { IVerificationsCommon } from './VerificationsCommon.interface';

export default class VerificationsCommon implements IVerificationsCommon {
  option: YesNoOption;
  method: string;
  date: number;

  static build = (data: IVerificationsCommon) => new VerificationsCommon(data);
  static blank = () => new VerificationsCommon();

  /**
   * Constructor
   * @param {IVerificationsCommon} data
   */
  constructor(data?: IVerificationsCommon) {
    this.option = YesNoOption.of(data?.option?.name);
    this.method = data?.method || '';
    this.date = data?.date ? epoch(utc(data?.date)) : 0;
  }
}
